import { Components, Theme } from '@mui/material/styles';

export const dividerConfigs: Components<Theme>['MuiDivider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.palette.grey[300],
    }),
  },
};
